export default "__VITE_ASSET__BcRf6a3O__"